import { Table, Typography } from "antd";
import { selectExceptionData } from "../redux/selectors";
import { columns as staticColumns } from "./columns/columns";
import ExpandableStackTrace from "./stacktrace";
import { useMemo } from "react";
import { useSelector } from "react-redux";
const { Paragraph, Text } = Typography;

const ExceptionTable = ({ data }: { data: any }) => {
  const exceptionData = useSelector(selectExceptionData);

  const dynamicColumns = useMemo(() => {
    const existingKeys = staticColumns.map((col) => col.dataIndex);
    const extraKeys = new Set<string>();

    const sourceFilterOptions = Array.from(
      new Set(exceptionData.map((item: any) => item.source).filter(Boolean))
    ).map((value) => ({ text: value, value }));

    const updatedStaticColumns = staticColumns.map((col) => {
      if (col.dataIndex === "source") {
        return {
          ...col,
          filters: sourceFilterOptions,
          onFilter: (value: string, record: any) => record.source === value,
        };
      }
      return col;
    });

    exceptionData.forEach((item: any) => {
      Object.keys(item).forEach((key) => {
        if (
          !existingKeys.includes(key) &&
          key !== "stackTrace" &&
          key !== "index" &&
          key !== "innerExceptionMessage" &&
          key !== "source"
        ) {
          extraKeys.add(key);
        }
      });
    });

    const generatedColumns = Array.from(extraKeys).map((key) => ({
      title: key,
      dataIndex: key,
      key,
    }));

    return [...updatedStaticColumns, ...generatedColumns];
  }, [exceptionData]);

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Table
        columns={dynamicColumns}
        dataSource={data}
        rowKey={(record: any) => `${record.index}`}
        expandable={{
          expandedRowRender: (record) => {
            if (!record.stackTrace) return null;
            return (
              <div style={{ marginLeft: "2.5rem" }}>
                <Text strong>Stack Trace:</Text>
                <ExpandableStackTrace text={record.stackTrace} />
                {record.innerExceptionMessage && (
                  <>
                    <Text type="secondary">Inner Exception:</Text>
                    <Paragraph>{record.innerExceptionMessage}</Paragraph>
                  </>
                )}
              </div>
            );
          },
          rowExpandable: (record) => !!record.stackTrace,
        }}
        bordered
        pagination={{ pageSize: 10 }}
        scroll={{ y: "calc(100vh - 220px)" }}
      />
    </div>
  );
};

export default ExceptionTable;
